<template>
    <v-dialog v-model="dialog" :max-width="width ? width : '500px'">
        <v-card>
            <v-card-title class="text-h5 aviso">{{ title }}</v-card-title>
            <v-card-text class="mt-2">
                <div class="d-flex justify-center">
                    <div style="width: 350px;">
                        <h2 class="text-center">{{ content }}</h2>
                    </div>
                </div>
            </v-card-text>
            <v-card-actions class="justify-center">
                <v-btn color="secondary" @click="dialog = false">Cancelar</v-btn>
                <v-btn color="success" @click="confirm">Confirmar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    name: 'MessageDialog',
    props: ['value', 'title', 'content', 'width'],
    data(){
        return {
            dialog: false,
        }
    },
    created(){
        //
    },
    methods: {
        confirm(){
            this.$emit('submit')
        }
    },
    watch: {
        value(val){
            this.dialog = val;
        },
        dialog(val){
            this.$emit('input', val)
        }
    },
    computed: {
        //
    }
}
</script>